import Vue from 'vue/dist/vue'
import store from './store'
import i18n from './lang'
import VueLazyload from 'vue-lazyload'
import VueMeta from 'vue-meta'

import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'

import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

import InfoHelper from './components/dev/InfoHelper.vue'
Vue.component('InfoHelper', InfoHelper)

import { mapState } from 'vuex'
import TheReservation from './components/TheReservation.vue'
import CountrySelector from './components/CountrySelector.vue'
import CountrySelectorSmall from './components/CountrySelectorSmall.vue'
import Storage from '@/helpers/localStorage'
import pjson from '../package.json'
import './jquery/UserQuotes'
import './jquery/FormStyle'
// import lax from 'lax.js'

Vue.use(VueLazyload)
Vue.use(VueMeta)

let isWidgetSet = false
let widgetInterval

const setChatPosition = () => {
  const widgets = document.getElementsByClassName('widget-visible')
  if (!widgets.length) return

  const iframe = widgets[0].getElementsByTagName('iframe')

  if (!iframe.length) return

  if (window.innerWidth < 1240) {
    iframe[0].style.bottom = '95px'
  } else {
    iframe[0].style.bottom = '10px'
  }

  iframe[0].style.right = '10px'
}

const checkChatPosition = () => {
  if (isWidgetSet) {
    clearInterval(widgetInterval)
    isWidgetSet = false
    return
  }

  setChatPosition()

  isWidgetSet = true
}

const onResize = () => {
  setChatPosition()
}

window.onload = () => {
  widgetInterval = setInterval(checkChatPosition, 1000)
}

window.addEventListener('resize', onResize)

Vue.config.productionTip = false

const requireComponent = require.context(
  // The relative path of the components folder
  './components-inline-template',
  // Whether or not to look in subfolders
  true,
  // The regular expression used to match base component filenames
  /[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach((fileName) => {
  // Get component config
  const componentConfig = requireComponent(fileName)

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  )

  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  )
})

const isDev = process.env.NODE_ENV !== 'production'

import '@/scss/app.scss'
import 'vue-search-select/dist/VueSearchSelect.css'
import UniversalGoogleMap from './components/UniversalGoogleMap.vue'
import UniversalGoogleMapWithSearch from './components/UniversalGoogleMapWithSearch.vue'

Sentry.init({
  Vue,
  dsn: 'https://c497734861e441aaa3ba6a1710ba0a83@o1234832.ingest.sentry.io/6384612',
  integrations: [
    new BrowserTracing({
      tracingOrigins: ['localhost', 'leihbox.test', 'leihbox.viuone.com', /^\//],
    }),
  ],
  logErrors: isDev,
  release: pjson.version,
  environment: process.env.NODE_ENV,
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
})

const app = new Vue({
  el: '#app',
  store,
  i18n,
  delimiters: ['{[{', '}]}'],
  data() {
    return {
      isDev: false,
    }
  },
  computed: {
    ...mapState('products', ['filterByCountry']),
    ...mapState('user', ['shippingCountry']),
  },
  components: {
    TheReservation,
    CountrySelector,
    CountrySelectorSmall,
    UniversalGoogleMap,
    UniversalGoogleMapWithSearch,
  },
  created() {
    if (isDev) {
      window.addEventListener('keypress', this.onKeypress)
    }

    this.$store.dispatch('user/setCurrentLanguage')
    this.$i18n.locale = this.$store.state.user.currentLanguage
  },
  destroyed() {
    if (isDev) {
      window.removeEventListener('keypress', this.onKeypress)
    }
  },
  mounted() {
    if (Storage.getIsDev()) {
      console.log(`APP VERIONS: ${pjson.version}; env: ${process.env.NODE_ENV}`)
      document.getElementsByTagName('body')[0].classList.add('var_dev')
    }
  },
  methods: {
    onKeypress(ev) {
      const key = ev.which || ev.keyCode // Detecting keyCode
      const ctrl = ev.ctrlKey ? ev.ctrlKey : key === 17 ? true : false

      if (key == 12 && ctrl) {
        this.isDev = !this.isDev
      }
    },
    showCountrySelector() {
      this.$refs.countrySelector.open()
    },
  },
})

export default app
